export const FETCH_CATEGORIES = 'categories/FETCH_CATEGORIES'
export const CREATE_CATEGORY = 'categories/CREATE_CATEGORY'
export const UPDATE_CATEGORY = 'categories/UPDATE_CATEGORY'
export const DELETE_CATEGORY = 'categories/DELETE_CATEGORY'



// WEBPACK FOOTER //
// ./client/store/modules/categories/mutation-types.js